import { useParams } from 'react-router-dom';
import InvoiceDetail from '../features/invoices/InvoiceDetail';

export const InvoiceDetailPage = () => {
  const { id } = useParams<{ id: string }>();
  return <InvoiceDetail id={id!} />;
};
